import { BillingSettingAPI } from "../api";
import { AccountingProduct } from "../classes"
import i18n from '@/plugins/vue-i18n';
export class BillingSetting {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
    this.typeString = ""
    if (data.type == "monthly") {
      this.typeString = i18n.t('monthly')
    } else if (data.type == "quantity") {
      this.typeString = i18n.t('area.per_unit')
    } else if (data.type == "day_of_month") {
      this.typeString = i18n.t('area.multiply_day_of_month')
    } else if (data.type == "minimum_unit") {
      this.typeString = i18n.t('area.calculate_by_real_minimum_unit')
    } else if (data.type == "minimum_cost") {
      this.typeString = i18n.t('area.calculate_by_real_minimum_cost')
    } else if (data.type == "monthly_square_metre") {
      this.typeString = i18n.t('area.calculate_by_square_metre_monthly')
    } else if (data.type == "day_of_month_square_metre") {
      this.typeString = i18n.t('area.calculate_by_square_metre_day_of_month')
    } else if (data.type == "step") {
      this.typeString = i18n.t('area.calculate_by_step')
    }
    this.accountingProduct = new AccountingProduct(data.accountingProduct)
    this.currencyCode = data.currencyCode || "THB"
  }
  static async getBillingSettingsByAreas(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByAreas(payload);
    return data.result.map((item) => new BillingSetting(item));
  }
  static async getBillingSettingsByIncludeArea(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByIncludeArea(payload);
    // Array Return
    data.result.map((item) => new BillingSetting(item));
    // Object Return
    // data.result = new BillingSetting(data.result)
    return data.result;
  }
  static async getBillingSettingsByMeters(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByMeters(payload);

    return data.result.map((item) => new BillingSetting(item));
  }
  static async getBillingSettings(payload) {
    const { data } = await BillingSettingAPI.getBillingSettings(payload);
    return data.result.map(item => (item = new BillingSetting(item)));
  }
  static async createBillingSetting(payload) {
    const { data } = await BillingSettingAPI.createBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async removeBillingSetting(payload) {
    const { data } = await BillingSettingAPI.removeBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async removeBillingSetting(payload) {
    const { data } = await BillingSettingAPI.removeBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async updateBillingSetting(payload) {
    const { data } = await BillingSettingAPI.updateBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async getBillingSettingsByIds(ids) {
    const { data } = await BillingSettingAPI.getBillingSettingsByIds(ids);
    return data.result.map(item => (item = new BillingSetting(item)));
  }
}
